import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'singularPlural',
})
export class SingularPluralPipe implements PipeTransform {
  transform(value: string, quantity: number): string {
    if (quantity <= 1) return value;
    else {
      var splited = value.split(' ');
      var finalValue = '';

      splited.forEach((word) => {
        if (word[word.length - 1] != 's') {
          finalValue = finalValue + word + 's ';
        } else {
          finalValue = finalValue + word + ' ';
        }
      });

      return finalValue.trim();
    }
  }
}
